import React, { useState, useMemo } from 'react';
import { Icons } from 'components';
import { debounce, map, closest, Fuse } from 'helpers';
import { mount } from './mount';
import { name } from 'styles/blocks/file.scss';
import * as css from 'styles/blocks/file-search.scss';

export const FileSearchContainer = mount('app-file-search', () =>
  <FileSearch files={getFiles()} />
);

function getFiles() {
  const fileClassName = name.split(' ').shift();
  const files = map(document.querySelectorAll(`.${fileClassName}`), element => ({
    href: element.parentNode.href,
    name: element.innerHTML.replace(/<[^>]+>/g, '').replace(/&amp;/g, '&'),
  }));
  return new Fuse(files, { keys: ['name'] });
}

function FileSearch({ files }) {
  const [ search, setSearch ] = useState('');
  const createOnFocusChange = () => debounce(() => {
    const containerClassName = css.container.split(' ').shift();
    const hasFocusWithin = closest(document.activeElement, `.${containerClassName}`);
    if (!hasFocusWithin) setSearch('');
  }, 100);
  const onFocusChange = useMemo(createOnFocusChange, []);
  return (
    <div tabIndex="-1" onFocus={onFocusChange} onBlur={onFocusChange}>
      <span className={css.fieldIcon + ' icon'}>
      <svg viewBox="0 0 511.999 511.999"><path d="M508.87 478.7L360.14 329.99a201.62 201.62 0 0045.2-127.31C405.33 90.92 314.41 0 202.66 0S0 90.92 0 202.67s90.92 202.66 202.67 202.66c48.2 0 92.48-16.98 127.3-45.19l148.74 148.74a10.67 10.67 0 0015.08 0l15.08-15.09a10.67 10.67 0 000-15.08zm-306.2-116.03c-88.23 0-160-71.77-160-160s71.77-160 160-160 160 71.77 160 160-71.77 160-160 160z"/></svg>
      </span>
      <input className={css.search} value={search} onChange={e => setSearch(e.target.value)} type="text" placeholder="Search.." />
      <ul className={css.list}>
        { files.search(search).slice(0, 20).map(file =>
          <li key={file.refIndex}>
            <a href={file.item.href} target="_blank" className={css.file}>
              { file.item.name }
            </a>
          </li>
        ) }
      </ul>
    </div>
  );
}
